import React from "react";

export const Button = ({
  children,
  className = "",
  dangerous,
  isLoading,
  compact = false,
  title = "",
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  dangerous?: boolean;
  isLoading?: boolean;
  compact?: boolean;
  title?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}) => (
  <button
    disabled={isLoading}
    title={title}
    className={`${
      dangerous
        ? `${isLoading ? "bg-red-200" : "bg-red-500"} hover:bg-red-700 `
        : `${isLoading ? "bg-blue-200" : "bg-blue-500"} hover:bg-blue-700 `
    }
      ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}
      ${className} text-white font-bold ${
      compact ? "py-1 px-2" : "py-2 px-4"
    } rounded focus:outline-none focus:shadow-outline`}
    onClick={onClick}
  >
    {children}
  </button>
);
